import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-cbb52236"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "c-title"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    style: _normalizeStyle($props.stitle),
    class: "title"
  }, _toDisplayString($props.info.title || $props.title), 5), $props.info.desc ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    style: _normalizeStyle($props.sdesc),
    class: "desc"
  }, _toDisplayString($props.info.desc), 5)) : _createCommentVNode("", true), !$props.noline ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    style: _normalizeStyle($props.sline),
    class: "line"
  }, null, 4)) : _createCommentVNode("", true)]);
}